import { defineMessages } from '../../i18n/messages';
import { englishText } from '../../utils/messageFallbacks';

/*
 * Shared by the index and the per-framework detail page, the way BlogArticlePage reuses
 * BlogIndexPage.messages: both emit the same "Integrations" crumb, and one definition
 * keeps them from drifting apart in 54 catalogues.
 *
 * Framework names and guide bodies are not here on purpose — they come from each MDX
 * file's frontmatter and are English-only, like the guides they introduce.
 */
const INTEGRATIONS_DEFINITIONS = {
  BREADCRUMB: {
    id: 'integrations.breadcrumb',
    text: 'Integrations',
    description:
      'Name of the integrations section in the schema.org BreadcrumbList structured data, following the "Home" crumb. A navigation trail label, so keep it short.',
  },
};

export const IntegrationsMessages = defineMessages(INTEGRATIONS_DEFINITIONS);

/** English fallbacks, used until `npm run lx:extract` adds these ids to en-US.json. */
export const IntegrationsText = englishText(INTEGRATIONS_DEFINITIONS);
